import { __decorate, __metadata } from "tslib";
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsEnum, IsNotEmpty, IsString, MinLength, ValidateIf } from 'class-validator';
export var PatchOperationEnum;
(function (PatchOperationEnum) {
    PatchOperationEnum["ADD"] = "add";
    PatchOperationEnum["TEST"] = "test";
    PatchOperationEnum["REMOVE"] = "remove";
    PatchOperationEnum["REPLACE"] = "replace";
    PatchOperationEnum["COPY"] = "copy";
    PatchOperationEnum["MOVE"] = "move";
})(PatchOperationEnum || (PatchOperationEnum = {}));
export const PatchValidationErrorDictionary = {
    SEQUENCE_NOT_AN_ARRAY: 'Patch sequence must be an array',
    OPERATION_NOT_AN_OBJECT: 'Operation is not an object',
    OPERATION_OP_INVALID: 'Operation op property is not one of operations defined in RFC-6902',
    OPERATION_PATH_INVALID: 'Operation path property is not a valid string',
    OPERATION_FROM_REQUIRED: 'Operation from property is not present',
    OPERATION_VALUE_REQUIRED: 'Operation value property is not present',
    OPERATION_VALUE_CANNOT_CONTAIN_UNDEFINED: 'Operation value property object has at least one undefined value',
    OPERATION_PATH_CANNOT_ADD: 'Cannot perform an add operation at the desired path',
    OPERATION_PATH_UNRESOLVABLE: 'Cannot perform the operation at a path that does not exist',
    OPERATION_FROM_UNRESOLVABLE: 'Cannot perform the operation from a path that does not exist',
    OPERATION_PATH_ILLEGAL_ARRAY_INDEX: 'Expected an unsigned base-10 integer value',
    OPERATION_VALUE_OUT_OF_BOUNDS: 'The specified index MUST NOT be greater than the number of elements in the array',
    TEST_OPERATION_FAILED: 'When operation is test and the test fails, applies to applyReducer',
};
export class JsonPatchOperationDto {
}
__decorate([
    Expose(),
    ApiProperty({ description: 'Operation to perform', example: 'add', enum: Object.values(PatchOperationEnum) }),
    IsEnum(PatchOperationEnum, { always: true }),
    __metadata("design:type", String)
], JsonPatchOperationDto.prototype, "op", void 0);
__decorate([
    Expose(),
    ApiProperty({ description: 'Target location path', example: '/user/name' }),
    IsString({ always: true }),
    MinLength(1, { always: true }),
    __metadata("design:type", String)
], JsonPatchOperationDto.prototype, "path", void 0);
__decorate([
    Expose(),
    ApiPropertyOptional({ description: 'Value to be applied on operation', example: 'John' }),
    ValidateIf((patch) => ![PatchOperationEnum.MOVE, PatchOperationEnum.REMOVE].includes(patch.op)),
    IsNotEmpty({ always: true }),
    __metadata("design:type", Object)
], JsonPatchOperationDto.prototype, "value", void 0);
__decorate([
    Expose(),
    ApiPropertyOptional({ description: 'Source path to move/copy value from', example: '/userName' }),
    ValidateIf((patch) => [PatchOperationEnum.MOVE, PatchOperationEnum.COPY].includes(patch.op)),
    IsString({ always: true }),
    MinLength(1, { always: true }),
    __metadata("design:type", String)
], JsonPatchOperationDto.prototype, "from", void 0);
//# sourceMappingURL=JsonPatchOperationDto.js.map